// Re-export dispatchStripeConnectionChanged for backward compatibility
export { dispatchStripeConnectionChanged } from '@/contexts/StripeConnectionContext';

// This hook now uses the Context to avoid multiple instances
import { useStripeConnectionContext } from '@/contexts/StripeConnectionContext';

export function useStripeStatus() {
  // Simply return the context values - all components share the same state
  return useStripeConnectionContext();
}
